import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    TextField,
    FormGroup,
    FormControlLabel,
    Switch,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    InputAdornment,
    IconButton,
    Checkbox,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { AddBox, AddCircle, RemoveCircle, Save, Search } from '@mui/icons-material';

import { useSearchParams } from 'react-router-dom';
import { makeid, myTimestampToDate } from '../utils/ui_utils';
import { LoadingButton } from '@mui/lab';
import { useAuth } from '../core/AuthProvider';
import { NumberInput } from '../components/NumberInput';



const newaward = {
    award_name: '',
    award_shortname: '',
    award_description: '',
    position: 1,
}





export const AwardLabelDialog = forwardRef(({ event_id, reloadFn, t, add_Award, edit_Award }, ref) => {
    const { user } = useAuth()
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newaward })
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [isInvalid, setIsInvalid] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)
    const [searchParams, setSearchParams] = useSearchParams()






    useImperativeHandle(ref, () => {
        return {
            onNew(list) {
                setCurElement({ ...newaward, award_code: makeid(8, true), order: list ? list.length + 1 : 1 })
                setIndex(-1)
                setIsNew(true)
                setIsEdited(false)
                setOpen(true);
            },
            onEdit(el, i, is_c) {
                console.log("IS CURRENT", is_c)
                setOpen(true);
                setIsNew(false)
                let _el = { ...newaward, ...el }
                setCurElement(_el)
                initData(is_c, el.id)
                setIndex(i)
                setIsEdited(false)
            }
        }
    })


    const handleClose = () => {
        setSearchParams({})
        setOpen(false);
    };


    const handleSave = () => {
        if (is_new) {
            add_Award(curElement)
        } else {
            edit_Award(curElement, index)
        }
        setOpen(false)
    }



    const onChangeHandler = (el, param_global) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'checkbox') {
            value = el.checked
        } else if (type === 'number') {
            value = parseInt(value)
        }

        if (value !== undefined) {
            if (param_global) {
                console.log(param_global, name)
                setCurElement({ ...curElement, [name]: parseInt(value), [param_global]: parseInt(value) + 1 })
            } else {
                setCurElement({ ...curElement, [name]: value })
            }
            setIsEdited(true)
        }
    }








    const initData = async (is_current, s_id) => {

    }

    useEffect(() => {
        return () => {

        }

    }, [])




    return (
        <div>

            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth={true}>
                <DialogTitle>
                    Etichetta personalizzata per premio:  {curElement.award_name}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <TextField
                            margin="dense"
                            id="award_name"
                            label={'Nome'}
                            fullWidth
                            name="award_name"
                            variant="standard"
                            value={curElement.award_name}
                            onChange={(ev) => onChangeHandler(ev.target)}
                        />
                        <TextField
                            margin="dense"
                            id="award_shortname"
                                    label={'Nome ridotto (esportazione)'}
                            fullWidth
                            name="award_shortname"
                            variant="standard"
                            value={curElement.award_shortname}
                            onChange={(ev) => onChangeHandler(ev.target)}
                        />
                        <NumberInput 
                            value={curElement.position}
                            onChangeHandler={onChangeHandler}
                            setCurElement={setCurElement}
                            setIsEdited={setIsEdited}
                            label={"posizione in classifica"}
                            name="position"
                            />

                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>chiudi</Button>
                    {isEdited &&
                        <LoadingButton key={'bs'} disabled={isInvalid} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingPosition="start">salva</LoadingButton>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})



